export default __webpack_public_path__ + "static/media/samsung-internet.0b901edc.svg";